var render, staticRenderFns
import script from "./SalesChar.vue?vue&type=script&lang=js&"
export * from "./SalesChar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702aaf75",
  null
  
)

export default component.exports